module.exports = function ($compileProvider) {
    $compileProvider.debugInfoEnabled('wowIsDebuggingEnabled' in window ? !!window.wowIsDebuggingEnabled : true);
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/compile.js
 **/